import { makeStyles, css } from '@conexasaude/conexa-hero'

export const useStyles = makeStyles({
  mainContainer: theme => css`
    margin: ${theme.spacing.md} auto;
  `,
})
